import * as React from 'react';

import { cn } from '@/lib/utils';

export const textAreaStyle = cn(
  // basic
  'tw:flex tw:w-full tw:bg-white tw:px-2 tw:py-1 tw:shadow-sm',
  // font size: inherit
  // 'tw:text-base',
  // border
  'tw:rounded-md tw:border tw:border-input',
  // placeholder
  'tw:placeholder:text-muted-foreground',
  // focus-visible
  'tw:focus-visible:outline-hidden tw:focus-visible:ring-4 tw:focus-visible:ring-blue-500/40',
  // disabled
  'tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
  // transition
  'tw:transition-shadow tw:duration-150 tw:ease-in-out',
);

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        textAreaStyle,
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
